function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 57,
    viewBox: "0 0 55 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.6694 56.202C26.6482 56.202 25.8239 55.355 25.8239 54.3058C25.8239 36.8482 19.205 30.0472 2.21481 30.0472C1.19367 30.0472 0.369385 29.2003 0.369385 28.1511C0.369385 27.1018 1.19367 26.2549 2.21481 26.2549C19.205 26.2549 25.8239 19.4539 25.8239 1.99629C25.8239 0.947062 26.6482 0.100098 27.6694 0.100098C28.6905 0.100098 29.5148 0.947062 29.5148 1.99629C29.5148 19.4539 36.1337 26.2549 53.1239 26.2549C54.145 26.2549 54.9693 27.1018 54.9693 28.1511C54.9693 29.2003 54.145 30.0472 53.1239 30.0472C36.1337 30.0472 29.5148 36.8482 29.5148 54.3058C29.5148 55.355 28.6905 56.202 27.6694 56.202ZM15.3788 28.1384C21.5425 30.3127 25.541 34.4338 27.6694 40.767C29.7854 34.4338 33.7962 30.3254 39.9599 28.1384C33.7962 25.9641 29.7977 21.8431 27.6694 15.5098C25.541 21.8431 21.5425 25.9515 15.3788 28.1384Z",
    fill: "pink",
    style: {
      filter: "drop-shadow(1px 1px 2.5px pink)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.da5d0ed520237b6d3df705ddbdcd8508.svg";
export { ForwardRef as ReactComponent };